import React from 'react';

import { ReactComponent as Icon } from '../../../assets/station-group.svg';

export const StationGroupIcon = ({size, color}) => {
    return (
        <Icon alt="station-group" style={{ width: size + 'px', fill: color }} />
    );
};